import useAuth from "../../../../hooks/useAuth";
import { useEffect, useState } from "react";
import {deleteEventFromDb, downloadFuneralMemo, getEventAddedInfos} from "../../../../api/pro/eventReq";
import Missing from "../../../Missing";
import FormThoughts from "../../../../forms/deceased/infos_obs/FormThoughts";
import FormAddedInfos from "../../../../forms/deceased/infos_obs/FormAddedInfos";
import { useParams } from "react-router-dom";
import { joinWithoutRepeatingWord, formatVisitSchedule } from "../../../../helper/tools";

export default function ObsequesInfos({deceasedInfos, eventId, setEventId, eventKey, setEventKey, eventList, apiEventList, apiDeceasedInfos, setShowAddEventModal}) {
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    
    const [ infosData, setInfosData ] = useState();
    const [ showThoughtsModal, setShowThoughtsModal ] = useState(false);
    const [ showAddedInfosModal, setShowAddedInfosModal ] = useState(false);
    const [ currentEventIndex, setCurrentEventIndex ] = useState(0);
    const [ eventsPerPage, setEventsPerPage ] = useState(4);

    // Fonction pour calculer le nombre d'événements selon la taille d'écran
    const getEventsPerPage = () => {
        const width = window.innerWidth;
        
        // Largeur minimale d'une carte (300px) + marges (20px) + gap moyen (15px)
        const cardMinWidth = 335;
        const arrowsSpace = 80; // Espace pour les flèches gauche/droite
        const containerPadding = 40; // Padding du conteneur (20px de chaque côté)
        
        // Calculer l'espace disponible pour les cartes
        const availableWidth = width - arrowsSpace - containerPadding;
        
        // Calculer combien de cartes de taille minimale peuvent tenir
        const maxCards = Math.floor(availableWidth / cardMinWidth);
        
        // Retourner au minimum 1 carte, au maximum le nombre calculé
        return Math.max(1, maxCards);
    };

    // Gérer le redimensionnement de l'écran
    useEffect(() => {
        const handleResize = () => {
            setEventsPerPage(getEventsPerPage());
            // Réinitialiser l'index si nécessaire
            setCurrentEventIndex(prev => {
                const newEventsPerPage = getEventsPerPage();
                const maxIndex = Math.max(0, (eventList?.length || 0) - newEventsPerPage);
                return Math.min(prev, maxIndex);
            });
        };

        // Définir la valeur initiale
        handleResize();

        // Écouter les changements de taille
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [eventList?.length]);


    const apiEventAddedInfos = async () => {
        const response = await getEventAddedInfos(token, id)
        setInfosData(response)
    }

    useEffect(() => {
        if (!infosData) {
            apiEventAddedInfos()
        }
    }, [ infosData, id ]);

    const handleDeleteEvent = async (id,typeKey) => {
        const body = {
            eventId: id,
            eventKey: typeKey
        }
        if (window.confirm("Voulez-vous vraiment supprimer cet événement ?")) {
            await deleteEventFromDb(token, body);
            setEventId(0);
            setEventKey(undefined);
            await apiEventList();
            await apiDeceasedInfos();
        }
    }

    const handleAddEvent = () => {
        setEventId(0);
        setEventKey(undefined);
        setShowAddEventModal(true);
    }

    const selectActiveEvent = (activeId, activeKey) => {
        setEventId(activeId)
        setEventKey(activeKey)
    }

    const handlePrevEvents = () => {
        setCurrentEventIndex(prev => Math.max(0, prev - 1));
    }

    const handleNextEvents = () => {
        setCurrentEventIndex(prev => Math.min(eventList.length - eventsPerPage, prev + 1));
    }

    const visibleEvents = Array.isArray(eventList) ? eventList.slice(currentEventIndex, currentEventIndex + eventsPerPage) : [];
    const showPrevArrow = currentEventIndex > 0 && visibleEvents.length > 0;
    const showNextArrow = Array.isArray(eventList) && eventList.length > eventsPerPage && currentEventIndex < eventList.length - eventsPerPage;


    return (
        <>
            { deceasedInfos?.error &&
                <Missing />
            }
            { (!deceasedInfos?.error) &&
                <>
                    { showThoughtsModal &&
                        <div className="modal add-thoughts">
                            <div>
                                <FormThoughts
                                    apiEventAddedInfos={apiEventAddedInfos}
                                    thoughts={infosData?.thoughtsTo}
                                />
                            </div>
                        </div>
                    }
                    { showAddedInfosModal &&
                        <div className="modal add-infos">
                            <div>
                                <FormAddedInfos
                                    apiEventAddedInfos={apiEventAddedInfos}
                                    setShowModal={setShowAddedInfosModal}
                                    legend="Informations complémentaires"
                                    infos={infosData?.addedInfos}
                                />
                            </div>
                        </div>
                    }
                    <div className="events-carousel-wrapper">
                        {showPrevArrow && (
                            <button 
                                className="carousel-arrow carousel-arrow-left" 
                                onClick={handlePrevEvents}
                                type="button"
                            ><i className="fa fa-chevron-left"/>
                            </button>
                        )}
                        <div className="deceased-infos-content flex obseques">
                            { visibleEvents?.length > 0 ?
                                visibleEvents?.map((event, index) => (
                                <div 
                                    onClick={() => selectActiveEvent(event?.id, event?.typeKey)}
                                    className={`deceased-infos-column ${(eventId === event?.id && eventKey === event?.typeKey) ? 'selected' : ''}`}
                                    key={index}
                                >
                                    {(eventId === event?.id && eventKey === event?.typeKey) && (
                                        <button 
                                            className="delete-event-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteEvent(event?.id, event?.typeKey);
                                            }}
                                            type="button"
                                            title="Supprimer cet événement"
                                        >
                                            <i className="fa fa-trash-alt"></i>
                                        </button>
                                    )}
                                    <legend>{event?.eventTypeLabel || event?.typeLabel }</legend>
                                    <div>
                                        <span>{joinWithoutRepeatingWord(event?.placeType, event?.placeName)}</span>
                                    </div>
                                    <div>
                                        <span>{event?.date}</span>
                                    </div>
                                    <div>
                                        <span>{event?.visitInfosData ? formatVisitSchedule(event.visitInfosData) : (event?.time && `à ${event.time}`)}</span>
                                    </div>
                                </div>
                            )) :
                            <div className="no-event">
                                <span>Pas d'événements pour ce défunt</span>
                                <button onClick={handleAddEvent} className="green-button">
                                    <i className="fa fa-pen-to-square"/>
                                    <span>Ajouter un événement</span>
                                </button>
                            </div>
                            }
                        </div>
                        {showNextArrow && (
                            <button 
                                className="carousel-arrow carousel-arrow-right" 
                                onClick={handleNextEvents}
                                type="button"
                            ><i className="fa fa-chevron-right"/>
                            </button>
                        )}
                    </div>
                </>
            }
        </>
    )
}